module.exports = __webpack_public_path__ + "files/7106421cd4227a61576d425c64263141.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/people-5.png
// module id = 1369
// module chunks = 59